import { createNextTableContext } from '../../../shared/modules/next-table/context/context';

export const CashRegisterChecksTableContext = createNextTableContext();
export const CashRegisterDepositsTableContext = createNextTableContext();
export const CashRegisterWithdrawsTableContext = createNextTableContext();
export const CashRegisterShiftsTableContext = createNextTableContext();
export const CashRegisterXReportsTableContext = createNextTableContext();
